"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESCAPE_KEYS = exports.SELECTION_KEYS = exports.ARROW_LEFT_KEYS = exports.ARROW_RIGHT_KEYS = exports.ARROW_UP_KEYS = exports.ARROW_DOWN_KEYS = exports.NavDirections = void 0;
const react_1 = require("react");
const noop_1 = __importDefault(require("lodash/noop"));
const useKeyEvent_1 = __importDefault(require("./useKeyEvent"));
var NavDirections;
(function (NavDirections) {
    NavDirections["UP"] = "up";
    NavDirections["DOWN"] = "down";
    NavDirections["LEFT"] = "left";
    NavDirections["RIGHT"] = "right";
})(NavDirections = exports.NavDirections || (exports.NavDirections = {}));
exports.ARROW_DOWN_KEYS = ["ArrowDown"];
exports.ARROW_UP_KEYS = ["ArrowUp"];
exports.ARROW_RIGHT_KEYS = ["ArrowRight"];
exports.ARROW_LEFT_KEYS = ["ArrowLeft"];
exports.SELECTION_KEYS = ["Enter", " "];
exports.ESCAPE_KEYS = ["Escape"];
function useFullKeyboardListeners({ ref, // the reference for the component that listens to keyboard
onSelectionKey = noop_1.default, onArrowNavigation = noop_1.default, onEscape = noop_1.default, useDocumentEventListeners = false, focusOnMount = false }) {
    const listenerOptions = (0, react_1.useMemo)(() => {
        if (useDocumentEventListeners)
            return undefined;
        return {
            ref,
            preventDefault: true,
            stopPropagation: true
        };
    }, [useDocumentEventListeners, ref]);
    const onArrowDown = (0, react_1.useCallback)(() => onArrowNavigation(NavDirections.DOWN), [onArrowNavigation]);
    const onArrowUp = (0, react_1.useCallback)(() => onArrowNavigation(NavDirections.UP), [onArrowNavigation]);
    const onArrowRight = (0, react_1.useCallback)(() => onArrowNavigation(NavDirections.RIGHT), [onArrowNavigation]);
    const onArrowLeft = (0, react_1.useCallback)(() => onArrowNavigation(NavDirections.LEFT), [onArrowNavigation]);
    (0, useKeyEvent_1.default)(Object.assign({ keys: exports.ARROW_DOWN_KEYS, callback: onArrowDown }, listenerOptions));
    (0, useKeyEvent_1.default)(Object.assign({ keys: exports.ARROW_UP_KEYS, callback: onArrowUp }, listenerOptions));
    (0, useKeyEvent_1.default)(Object.assign({ keys: exports.ARROW_RIGHT_KEYS, callback: onArrowRight }, listenerOptions));
    (0, useKeyEvent_1.default)(Object.assign({ keys: exports.ARROW_LEFT_KEYS, callback: onArrowLeft }, listenerOptions));
    (0, useKeyEvent_1.default)(Object.assign({ keys: exports.SELECTION_KEYS, callback: onSelectionKey }, listenerOptions));
    (0, useKeyEvent_1.default)(Object.assign({ keys: exports.ESCAPE_KEYS, callback: onEscape }, listenerOptions));
    (0, react_1.useEffect)(() => {
        var _a;
        if (!focusOnMount || useDocumentEventListeners)
            return;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [focusOnMount, ref, useDocumentEventListeners]);
}
exports.default = useFullKeyboardListeners;
